import axios from 'axios';

const list = (data) => axios.get('/custom/culture/list', data);
const save = (data) => axios.post('/custom/culture/saveOrUpdate', data);
const del = (data) => axios.post('/custom/culture/delete', data); //delete

export default {
  list,
  save,
  del,
}


